/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
import { defineCustomElements, applyPolyfills } from '@prism-ui/core/loader';
applyPolyfills().then(() => defineCustomElements());
export const EntRecentActivity = /*@__PURE__*/ createReactComponent('ent-recent-activity');
export const PrismAccordion = /*@__PURE__*/ createReactComponent('prism-accordion');
export const PrismAutosuggest = /*@__PURE__*/ createReactComponent('prism-autosuggest');
export const PrismAvatar = /*@__PURE__*/ createReactComponent('prism-avatar');
export const PrismBadge = /*@__PURE__*/ createReactComponent('prism-badge');
export const PrismBanner = /*@__PURE__*/ createReactComponent('prism-banner');
export const PrismBox = /*@__PURE__*/ createReactComponent('prism-box');
export const PrismBreadcrumb = /*@__PURE__*/ createReactComponent('prism-breadcrumb');
export const PrismButton = /*@__PURE__*/ createReactComponent('prism-button');
export const PrismCard = /*@__PURE__*/ createReactComponent('prism-card');
export const PrismCarousel = /*@__PURE__*/ createReactComponent('prism-carousel');
export const PrismCheckbox = /*@__PURE__*/ createReactComponent('prism-checkbox');
export const PrismCheckboxGroup = /*@__PURE__*/ createReactComponent('prism-checkbox-group');
export const PrismDataGrid = /*@__PURE__*/ createReactComponent('prism-data-grid');
export const PrismForm = /*@__PURE__*/ createReactComponent('prism-form');
export const PrismGrid = /*@__PURE__*/ createReactComponent('prism-grid');
export const PrismHeader = /*@__PURE__*/ createReactComponent('prism-header');
export const PrismHero = /*@__PURE__*/ createReactComponent('prism-hero');
export const PrismIcon = /*@__PURE__*/ createReactComponent('prism-icon');
export const PrismImg = /*@__PURE__*/ createReactComponent('prism-img');
export const PrismInput = /*@__PURE__*/ createReactComponent('prism-input');
export const PrismLayout = /*@__PURE__*/ createReactComponent('prism-layout');
export const PrismLegalAgreement = /*@__PURE__*/ createReactComponent('prism-legal-agreement');
export const PrismLineitem = /*@__PURE__*/ createReactComponent('prism-lineitem');
export const PrismLoading = /*@__PURE__*/ createReactComponent('prism-loading');
export const PrismMenu = /*@__PURE__*/ createReactComponent('prism-menu');
export const PrismModal = /*@__PURE__*/ createReactComponent('prism-modal');
export const PrismNextStepBar = /*@__PURE__*/ createReactComponent('prism-next-step-bar');
export const PrismNotification = /*@__PURE__*/ createReactComponent('prism-notification');
export const PrismPageHeading = /*@__PURE__*/ createReactComponent('prism-page-heading');
export const PrismPagination = /*@__PURE__*/ createReactComponent('prism-pagination');
export const PrismProgress = /*@__PURE__*/ createReactComponent('prism-progress');
export const PrismRadio = /*@__PURE__*/ createReactComponent('prism-radio');
export const PrismRadioGroup = /*@__PURE__*/ createReactComponent('prism-radio-group');
export const PrismSectionHeading = /*@__PURE__*/ createReactComponent('prism-section-heading');
export const PrismSelect = /*@__PURE__*/ createReactComponent('prism-select');
export const PrismStepperNavigation = /*@__PURE__*/ createReactComponent('prism-stepper-navigation');
export const PrismSwitch = /*@__PURE__*/ createReactComponent('prism-switch');
export const PrismTab = /*@__PURE__*/ createReactComponent('prism-tab');
export const PrismTabs = /*@__PURE__*/ createReactComponent('prism-tabs');
export const PrismText = /*@__PURE__*/ createReactComponent('prism-text');
export const PrismTextarea = /*@__PURE__*/ createReactComponent('prism-textarea');
export const PrismTooltip = /*@__PURE__*/ createReactComponent('prism-tooltip');
//# sourceMappingURL=components.js.map